// extracted by mini-css-extract-plugin
module.exports = {"promo_message":"promo_message-1AmSV","header":"header-3qmoG"};